import BaseCtrl from 'edge/platform/base/BaseCtrl';
import flowFactory from 'edge/platform/flow/FlowFactory';
import flowConfig from '../config/FlowConfig';

export default [
    '$scope',
    '$filter',
    '$q',
    'WizardFlowService',
    'qnb.LoadSaveService',
    'ViewModelService',
    'AvailabilityService',
    'TranslateService',
    'qnb.ViewModelCtx',
    '$stateParams',
    'StateUtils',
    'LocaleService',
    'qnb.ActionMessageUtil',
    'EventHub',
    'AgeAllowedToDrive',
    'MaximumAge',
    'quickquote.QuickQuoteService',
    'QuoteJumpToStepService',

    (
        $scope, $filter, $q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService,
        ViewModelCtx, $stateParams, StateUtils, LocaleService, ActionMessageUtil, EventHub, AgeAllowedToDrive, MaximumAge, QuickQuoteService, QuoteJumpToStepService
    ) => {
        const ctrl = Object.create(BaseCtrl);
        const stepIndices = {
            VEHICLE_PANEL: 0,
            ADDRESS_PANEL: 1,
            DRIVER_PANEL: 2,
            ESTIMATE_PANEL: 3
        };
        const flowDefn = flowConfig($q, wizardFlowService, LoadSaveService, ViewModelService, AvailabilityService, TranslateService, ViewModelCtx, $stateParams, StateUtils, ActionMessageUtil, AgeAllowedToDrive, MaximumAge, QuickQuoteService, EventHub, QuoteJumpToStepService);
        const flowModelFactory = flowFactory.get($q, EventHub)(flowDefn);
        const flowModel = flowModelFactory.start();
        const stepValidFuncs = flowModel.steps.map((step) => {
            // step - Defined in the FlowConfig
            return {

                isValid: () => {
                    // The isValid() below is the isValid() function from the flowModel
                    const isValidFnOfStep = step.isValid();
                    // Since we want to reuse the isValid() of the step we need to call it with the model.
                    return $scope.model && isValidFnOfStep($scope.model);
                }
            };
        });

        ctrl.init = function () {
            $scope.model = ViewModelService.create({
                policyAddress: {},
                productCode: 'PersonalAuto',
                lobCoverables: {
                    personalAuto: {}
                },
                age: {},
                termsChecked: {
                    value: false
                }
            }, 'pc', 'edge.capabilities.quote.streamlined.dto.StreamlinedQuoteDTO');
            $scope.flow = flowModel;
            $scope.stepValidFuncs = stepValidFuncs;
            $scope.driversAllowedMinAge = AgeAllowedToDrive;
            $scope.driversAllowedMaxAge = MaximumAge;
            Object.defineProperty($scope, 'currentStepIndex', {
                get: () => flowModel.steps.indexOf(flowModel.currentStep)
            });
            $scope.selectedProduct = null;
        };

        ctrl.getSectionClass = function (stepIdx) {
            if (stepIdx === $scope.currentStepIndex) {
                return 'gw-active-section';
            } else if (stepIdx < $scope.currentStepIndex) {
                return 'gw-inactive-section-left';
            }
            return 'gw-inactive-section-right';
        };

        ctrl.nextPanel = function () {
            const deferred = $q.defer();
            if ($scope.currentStepIndex <= $scope.flow.steps.length - 1) {
                flowModel.next($scope.model, $scope.selectedProduct).then(newModel => {
                    $scope.model = newModel.model;
                    deferred.resolve();
                });
            } else {
                deferred.reject();
            }
            return deferred.promise;
        };

        ctrl.previousPanel = function () {
            const thereIsAPanelToSwitchTo = $scope.currentStepIndex > stepIndices.VEHICLE_PANEL;

            if (thereIsAPanelToSwitchTo) {
                flowModel.previous($scope.model);
            }
        };

        ctrl.isPanelValid = function () {
            if ($scope.stepValidFuncs[$scope.currentStepIndex]) {
                return $scope.stepValidFuncs[$scope.currentStepIndex].isValid();
            }
        };

        ctrl.getVisibilityClass = function (index) {
            let activeClass = '';
            if ($scope.currentStepIndex !== index) {
                activeClass = 'gw-pa-quick-quote-hidden-section';
            }
            return activeClass;
        };

        ctrl.getNextLabel = function () {
            if ($scope.currentStepIndex === stepIndices.ESTIMATE_PANEL) {
                return 'quoteandbind.quickquote.pa.views.pa-quick-quote.Proceed to Full Quote';
            }
            return 'quoteandbind.quickquote.pa.views.pa-quick-quote.Next';
        };

        return ctrl.create($scope);
    }
];
